import axios from 'axios';

import * as DatetimeHelper from '../helpers/DatetimeHelper';

export const getInfo = async id => {
    const uri = `/v1/bbs/${id}`;
    return axios.get(uri)
        .then(result => {
            console.log(result);
            const response = result.data;
            let info = response.data.info;
            console.log('info', info);
            info.createdDatetime = DatetimeHelper.convertTimestampToLocalDatetime(info.createdAt);
            console.log(info);
            return info;
        })
}

export const getList = async (page, codeList = []) => {
    let uri = `/v1/bbs?page=${page}`;
    if (codeList.length > 0) {
        uri += `&code=${codeList.join(',')}`;
    }
    return axios.get(uri)
        .then(result => {
            console.log(result);
            const response = result.data;

            let { list, totalCount, hasNextPage } = response.data;


            for (let i = 0; i < list.length; i++) {
                list[i].createdDatetime = DatetimeHelper.convertTimestampToLocalDatetime(list[i].createdAt);
            }

            console.log(response.data);
            return {
                list, totalCount, hasNextPage
            }
        })
}